export default __webpack_public_path__ + "static/media/Mining Axe of the Oxmal.964b0dec.jpg";